import { render } from "./recoveryPass.vue?vue&type=template&id=bbec7558&scoped=true"
import script from "./recoveryPass.vue?vue&type=script&lang=js"
export * from "./recoveryPass.vue?vue&type=script&lang=js"

import "./recoveryPass.vue?vue&type=style&index=0&id=bbec7558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbec7558"]])

export default __exports__